import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import Radium from "radium";
import { httpGet } from "../../Util/http";
import { routeActions } from "redux-simple-router";
import { semanticColors } from "../../Globals/styles";
import animations from "../../Globals/animations";
import Modal from "../../Common/modal";
import Nearmiss from "./Assessment/index";
import auth from "../../Login/authService";

//TODO
//update total registreret i kanban

class Workplace extends Component {
  constructor(props) {
    super(props);
    var location = this.props.location.pathname.split("/");
    this.state = {
      isActive: location[location.length - 1],
      hide: true,
      safety: false,
      understood: false,
    };
  }
  componentWillMount = () => {
    const { params } = this.props;
    if (params.workplaceId === "opret") {
      this.setState({
        isCreate: true,
      });
    } else {
      httpGet(
        process.env.REACT_APP_webApiEndPoint +
          `api/arbejdsmiljo/${params.workplaceId}/ack`
      )
        .then((r) => r.json())
        .then((r) => {
          for (var i = 0, len = r.userAcks.length; i < len; i++) {
            let user = r.userAcks[i];
            if (user.id.toLowerCase() === auth.getProfile().nickname) {
              this.setState({
                understood: user.understood,
                safety: user.safety,
              });
              break;
            }
          }
          var lookup = {};
          for (var i = 0, len = r.userAcks.length; i < len; i++) {
            lookup[r.userAcks[i].id.toLowerCase()] = r.userAcks[i];
          }
          this.setState({
            acks: lookup,
          });
        })
        .catch(() => {});
    }
  };

  componentWillReceiveProps = (nextProps) => {
    if (
      nextProps.params.workplaceId !== this.props.workplaceId &&
      this.state.isCreate
    ) {
      this.setState({
        isCreate: false,
      });
    }
    let nextLocation = nextProps.location.pathname.split("/");
    if (this.state.isActive !== nextLocation[nextLocation.length - 1]) {
      this.setState({
        isActive: nextLocation[nextLocation.length - 1],
      });
    }
  };
  generateUrl = (whereTo) => {
    const { params } = this.props;
    return (
      "/afdeling/" +
      params.departmentId +
      "/arbejdssted/" +
      params.workplaceId +
      "/" +
      whereTo
    );
  };
  menuOnClick = (whereTo) => {
    this.setState({
      isActive: whereTo,
    });
    const { dispatch } = this.props;
    if (this.state.isCreate) return;
    return dispatch(routeActions.push(this.generateUrl(whereTo)));
  };

  openGodtSet = () => {
    this.setState({
      hide: false,
    });
  };

  render() {
    const { params, dispatch } = this.props;
    return (
      <div style={styles.bodyOverride}>
        <div style={styles.view}>
          <div style={styles.container} className="container-fluid">
            <div style={styles.menu}>
              {this.state.isCreate ? (
                <div style={styles.isCreateOverlay} />
              ) : null}
              <div style={{ textAlign: "center" }}>
                <div
                  key={1}
                  className="waves-btn"
                  onClick={() => this.menuOnClick("oversigt")}
                  style={[
                    styles.menuBtns,
                    this.state.isActive === "oversigt"
                      ? styles.activeButton
                      : null,
                  ]}
                >
                  OVERSIGT
                </div>
                {/* {this.state.understood && this.state.safety || auth.getProfile().role !== 'Formand' ? */}
                {true ? (
                  <div
                    key={2}
                    className="waves-btn"
                    style={[
                      styles.menuBtns,
                      this.state.isActive === "dagrapport"
                        ? styles.activeButton
                        : null,
                    ]}
                    onClick={() => this.menuOnClick("dagrapport")}
                  >
                    DAGRAPPORT
                  </div>
                ) : (
                  <div
                    onClick={() => {
                      alert(
                        "For at tilgå dagrapporter skal du først gennemgå arbejdsmiljø fanen"
                      );
                      this.menuOnClick("arbejdsmiljo");
                    }}
                    key={21}
                    style={styles.menuBtns2}
                  >
                    DAGRAPPORT
                  </div>
                )}
                <div
                  key={3}
                  className="waves-btn"
                  style={[
                    styles.menuBtns,
                    this.state.isActive === "billeder"
                      ? styles.activeButton
                      : null,
                  ]}
                  onClick={() => this.menuOnClick("billeder")}
                >
                  BILLEDER
                </div>

                {auth.getProfile().role !== "Formand" ? (
                  <div
                    key={4}
                    className="waves-btn"
                    style={[
                      styles.menuBtns,
                      this.state.isActive === "pkalk"
                        ? styles.activeButton
                        : null,
                    ]}
                    onClick={() => this.menuOnClick("pkalk")}
                  >
                    P-KALK
                  </div>
                ) : null}

                {auth.getProfile().role !== "Formand" ? (
                  <div
                    key={5}
                    className="waves-btn"
                    style={[
                      styles.menuBtns,
                      this.state.isActive === "invoice"
                        ? styles.activeButton
                        : null,
                    ]}
                    onClick={() => this.menuOnClick("invoice")}
                  >
                    FAKTURA
                  </div>
                ) : null}

                {auth.getProfile().role !== "Formand" ? (
                  <div
                    key={6}
                    className="waves-btn"
                    style={[
                      styles.menuBtns,
                      this.state.isActive === "estimat"
                        ? styles.activeButton
                        : null,
                    ]}
                    onClick={() => this.menuOnClick("estimat")}
                  >
                    ESTIMAT
                  </div>
                ) : null}
                <div
                  key={8}
                  className="waves-btn"
                  style={[
                    styles.menuBtns,
                    this.state.isActive === "arbejdsmiljo"
                      ? styles.activeButton
                      : null,
                  ]}
                  onClick={() => this.menuOnClick("arbejdsmiljo")}
                >
                  ARBEJDSMILJØ
                </div>
                <div
                  key={9}
                  className="waves-btn"
                  style={[
                    styles.menuBtns,
                    this.state.isActive === "docs" ? styles.activeButton : null,
                    styles.noBorder,
                  ]}
                  onClick={() => this.menuOnClick("docs")}
                >
                  DOCS
                </div>
              </div>
            </div>

            <i
              onClick={() => {
                dispatch({ type: "KILL_WORKPLACE" });
                if (
                  params.departmentId === "00000000-0000-0000-0000-000000000000"
                ) {
                  var number = window.localStorage.getItem("wp");
                  window.location.assign(
                    window.location.origin + "/tilbud/sag/" + number
                  );
                } else {
                  dispatch(
                    routeActions.push("/afdeling/" + params.departmentId)
                  );
                }
              }}
              className="fa fa-times waves-icon"
              style={styles.closeButton}
            ></i>
            <Modal
              hide={this.state.hide}
              onClose={() => {
                this.setState({ hide: !this.state.hide, nearmissImage: null });
              }}
            >
              {this.state.hide ? null : (
                <Nearmiss finito={() => this.setState({ hide: true })} />
              )}
            </Modal>
            {React.Children.map(this.props.children, (child) =>
              React.cloneElement(child, {
                openGodtSet: this.openGodtSet,
                updateAck: (id, safety, understood) => {
                  let a = this.state.acks;
                  if (!a[id]) {
                    a[id] = {
                      id,
                      safety,
                      understood,
                    };
                  } else {
                    a[id].safety = safety;
                    a[id].understood = understood;
                  }
                  this.setState({
                    acks: a,
                  });
                },
                understood: this.state.understood,
                safety: this.state.safety,
                userAcks: this.state.acks,
              })
            )}
          </div>
        </div>
      </div>
    );
  }
}

var styles = {
  bodyOverride: {
    backgroundColor: semanticColors.default,
    position: "absolute",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
  },
  view: {
    animation: animations.fadeIn,
    position: "absolute",
    top: "0",
    left: "0",
    bottom: "0",
    right: "0",
    width: "100%",
    minWidth: "700px",
    height: "100%",
    zIndex: "1000",
    margin: "auto",
    paddingTop: "50px",
    backgroundColor: semanticColors.default,
    "@media (min-width: 1200px)": {
      maxWidth: "1170px",
      left: "50%",
      marginLeft: "-585px",
    },
    "@media print": {
      paddingTop: "10px",
    },
  },
  container: {
    height: "100%",
  },
  closeButton: {
    cursor: "pointer",
    fontSize: "26px",
    position: "absolute",
    top: "7px",
    right: "22px",
    color: semanticColors.text,
    height: "36px",
    width: "36px",
    lineHeight: "36px",
    zIndex: "100",
    "@media print": {
      display: "none",
    },
  },
  menu: {
    position: "absolute",
    top: "16px",
    height: "30px",
    width: "98%",
    "@media print": {
      display: "none",
    },
  },
  menuBtns: {
    display: "inline-block",
    padding: "0px 10px",
    height: "30px",
    lineHeight: "30px",
    borderRight: "1px solid",
    borderColor: semanticColors.mainBackground,
    borderRadius: "0px",
    cursor: "pointer",
    color: semanticColors.text,
    ":hover": {
      color: semanticColors.infoHover,
    },
  },
  menuBtns2: {
    display: "inline-block",
    padding: "0px 10px",
    height: "30px",
    lineHeight: "30px",
    borderRight: "1px solid",
    borderColor: semanticColors.mainBackground,
    borderRadius: "0px",
    color: "grey",
  },
  noBorder: {
    borderRight: "none",
  },
  activeButton: {
    color: semanticColors.info,
  },
  isCreateOverlay: {
    width: "100%",
    position: "absolute",
    height: "100%",
    top: "0",
    left: "0",
    zIndex: "1001",
    backgroundColor: semanticColors.default,
    opacity: "0.5",
  },
};

export const selectprops = (state) => {
  return {
    router: state.routing,
  };
};

var w = Radium(Workplace);
export default withRouter(connect(selectprops)(w));



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/index.jsx